import { Link, Style } from '@solidjs/meta';
import { For, Show } from 'solid-js';
import { useUrls } from 'Shared/UrlProvider';
import { VenueFonts } from 'Shared/model/venueSettings';
import { googleFontHref, uploadedFontFaceCss } from 'Shared/frontend/fonts/venueFonts';


export function VenueFontLinks(P:{fonts:VenueFonts})
{
	const urls = useUrls();

	return (<>
		<Show when={P.fonts.google.length > 0}>
			<Link rel='preconnect' href='https://fonts.googleapis.com' />
			<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		</Show>

		<For each={P.fonts.google}>{font =>
			<Link rel='stylesheet' href={googleFontHref(font.spec)} />
		}</For>

		<For each={P.fonts.external}>{font =>
			<Style>{font.css}</Style>
		}</For>

		<For each={P.fonts.uploaded}>{font =>
			<Style>{uploadedFontFaceCss(urls,font)}</Style>
		}</For>
	</>);
}
